import { Injectable } from '@angular/core';

import { User } from '../models/main';

const STORAGE_KEY = 'developerMode';

/**
 * Gestiona el "modo desarrollador" de la interfaz: cuando esta activo, los campos de formulario muestran un helper
 * con el endpoint y el path del payload al que corresponden, para facilitar las integraciones contra la API.
 *
 * Quien puede activarlo lo decide la organizacion desde el formulario de aplicaciones
 * (integrations.developerMode.enabled + la lista de usuarios en integrations.developerMode.fieldReferenceInfo).
 * Que este activo o no lo decide el propio usuario con el toggle de la barra superior; la preferencia se guarda en
 * localStorage, igual que el tema, y por tanto persiste entre recargas y navegaciones.
 */
@Injectable({ providedIn: 'root' })
export class DeveloperModeService {
  private allowed: boolean = false;
  private active: boolean = localStorage.getItem(STORAGE_KEY) === 'true';

  /**
   * Registra al usuario de la sesion. Lo llama la pantalla contenedora en cuanto resuelve el usuario, porque el
   * servicio vive en `common` y no puede depender del CacheService de cada proyecto.
   */
  setUser(user: User | undefined): void {
    const developerMode = user?.organization?.integrations?.developerMode;
    this.allowed = !!developerMode?.enabled && !!user && !!developerMode.fieldReferenceInfo?.includes(user.id);
  }

  /** La organizacion ha habilitado el modo desarrollador para este usuario: se puede ofrecer el toggle. */
  get available(): boolean {
    return this.allowed;
  }

  /** El usuario tiene el modo activado y ademas lo tiene permitido: hay que pintar los helpers. */
  get enabled(): boolean {
    return this.allowed && this.active;
  }

  toggle(): void {
    this.active = !this.active;
    localStorage.setItem(STORAGE_KEY, String(this.active));
  }
}
